import Link from 'gatsby-link';
import PropTypes from 'prop-types';
import React from 'react';

const Header = ({ title }) => (
  <header
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      margin: 'auto',
      maxWidth: '35em',
    }}
  >
    <div style={{ position: 'relative' }}>
      <span
        className="dn-m"
        style={{
          display: 'flex',
          alignItems: 'center',
          position: 'absolute',
          right: '100%',
          top: '50%',
          transform: 'translateY(-50%)',
          width: '20vw',
          marginRight: '.5em',
        }}
      >
        <span
          style={{
            flex: 1,
            marginRight: '3px',
            height: '3px',
            backgroundImage:
              'linear-gradient(to right, rgba(42,183,202,0) 0%, rgba(42,183,202,.35) 100%)',
          }}
        />
        <svg width="18" height="18">
          <path
            d="M1.028 9.19L0 12.354c0 .157.127.285.283.285h1.18l1.429-2.443c.26.09.553.14.864.14l3.733.153-2.056 7.134c0 .209.167.377.375.377h1.89l3.952-7.371 3.626.122c1.031 0 1.867-.796 1.867-1.776s-.836-1.776-1.867-1.776l-3.653.123L7.7 0H5.808a.376.376 0 0 0-.375.378L7.474 7.46l-3.719.152c-.32 0-.621.055-.888.15L1.462 5.361H.282A.284.284 0 0 0 0 5.645L1.028 8.81v.38z"
            fill="#448FA3"
          />
        </svg>
      </span>
      <div>
        <svg
          className="dn-sm"
          width="18"
          height="18"
          style={{
            marginRight: '.3em',
            transform: 'translateY(2px)',
          }}
        >
          <path
            d="M1.028 9.19L0 12.354c0 .157.127.285.283.285h1.18l1.429-2.443c.26.09.553.14.864.14l3.733.153-2.056 7.134c0 .209.167.377.375.377h1.89l3.952-7.371 3.626.122c1.031 0 1.867-.796 1.867-1.776s-.836-1.776-1.867-1.776l-3.653.123L7.7 0H5.808a.376.376 0 0 0-.375.378L7.474 7.46l-3.719.152c-.32 0-.621.055-.888.15L1.462 5.361H.282A.284.284 0 0 0 0 5.645L1.028 8.81v.38z"
            fill="#448FA3"
          />
        </svg>
        <Link to="/" style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>
          {title}
        </Link>
      </div>
    </div>
    <Link to="/about">Příběh</Link>
  </header>
);

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js